export interface AppConfig {
  apiBaseUrl: string;
  appTitle: string;
  allowDevAuth: boolean;
  devBitrixUserId: number;
  jobPollIntervalMs: number;
}

function readBoolean(value: boolean | string | undefined, fallback: boolean): boolean {
  if (typeof value === "boolean") return value;
  if (typeof value !== "string") return fallback;
  return ["1", "true", "yes", "on"].includes(value.trim().toLowerCase());
}

function readNumber(value: number | string | undefined, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

export function loadConfig(): AppConfig {
  const runtime = window.__STREAMER_AI_CONFIG__ ?? {};
  const env = import.meta.env;
  return {
    apiBaseUrl: trimTrailingSlash(
      runtime.apiBaseUrl || env.VITE_API_BASE_URL || "http://localhost:8080/api/v1",
    ),
    appTitle: runtime.appTitle || "ИИ-помощник техслужбы",
    allowDevAuth: readBoolean(
      runtime.allowDevAuth ?? env.VITE_ALLOW_DEV_AUTH,
      false,
    ),
    devBitrixUserId: readNumber(
      runtime.devBitrixUserId ?? env.VITE_DEV_BITRIX_USER_ID,
      1,
    ),
    jobPollIntervalMs: readNumber(
      runtime.jobPollIntervalMs ?? env.VITE_JOB_POLL_INTERVAL_MS,
      2500,
    ),
  };
}

export const appConfig = loadConfig();
